export default () => ({
  alignRight: {
    textAlign: 'right',
  },
  timeIndicator: {
    'font-size': 10,
    padding: 0,
    'padding-left': 10,
  },
  message: {
    padding: 0,
    'padding-left': 10,
    'font-size': 20,
  },
  item: {
    padding: 0,
  },
  authorName: {
    'margin-bottom': 0,
    'margin-top': 10,
  },
});
